var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useProfileContext } from '../ProfileContext';
import { PROFILE_STEPS } from '../enums';
import { getMaxNumPets, hasValidSummary, noPetsMissingProperty } from '../utils';
import Start from './Start';
import AddAnotherDogForm from './add_another_dog/page';
import AddOnsForm from './addons/page';
import AddressForm from './address/page';
import ContactInfoForm from './contact/page';
import petRoutes from './pet/page';
import CheckoutForm from './summary/page';
/**
 * User should only be able to access add_another_dog, addons,
 * and contact routes if all their pets have a recipe saved.
 */
var ValidPostPetRoute = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var _b = useProfileContext(), profileData = _b.profileData, profileBasePath = _b.profileBasePath;
    useEffect(function () {
        if (profileData.pets.length < 1) {
            console.error('Incomplete profile. Redirecting...');
            navigate(profileBasePath, { replace: true, viewTransition: true });
        }
        else if (!noPetsMissingProperty(profileData.pets, 'recipe')) {
            console.error('Incomplete pet profile. Redirecting...');
            navigate(profileBasePath, { replace: true, viewTransition: true });
        }
        else if (profileData.pets.length === getMaxNumPets(profileData.version) &&
            location.pathname.includes('add_another_dog')) {
            console.error('Max number of pets reached. Redirecting...');
            navigate("".concat(profileBasePath, "/addons"), { replace: true, viewTransition: true });
        }
    }, [profileData, navigate]);
    if (profileData.pets.length < 1 || !noPetsMissingProperty(profileData.pets, 'recipe')) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
/**
 * User should only be able to access address route if they have their contact info saved,
 * which assumes that all pets have a recipe saved.
 */
var ValidAddressRoute = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var _b = useProfileContext(), profileData = _b.profileData, profileBasePath = _b.profileBasePath;
    useEffect(function () {
        if (profileData.pets.length < 1) {
            console.error('Incomplete profile. Redirecting...');
            navigate(profileBasePath, { replace: true });
        }
        else if (!profileData.customerName || !profileData.email) {
            console.error('Incomplete profile. Redirecting...');
            navigate("".concat(profileBasePath, "/contact"), { replace: true });
        }
    }, [profileData, navigate]);
    if (profileData.pets.length < 1 || !profileData.customerName || !profileData.email) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
/**
 * User should only be able to access summary route if all their pets have a recipe
 * and have their address saved (which assumes that contact info is also saved).
 */
var ValidSummaryRoute = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var _b = useProfileContext(), profileData = _b.profileData, profileBasePath = _b.profileBasePath;
    useEffect(function () {
        if (!hasValidSummary(profileData)) {
            console.error('Incomplete profile. Redirecting...');
            navigate(profileBasePath, { replace: true });
        }
    }, [profileData, navigate]);
    if (!hasValidSummary(profileData)) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
var PersonalizedProfileRoutes = __spreadArray(__spreadArray([
    {
        index: true,
        loader: function () { return PROFILE_STEPS.start; },
        element: _jsx(Start, {}),
    },
    {
        path: 'add_another_dog',
        loader: function () { return PROFILE_STEPS.addAnotherDogForm; },
        element: (_jsx(ValidPostPetRoute, { children: _jsx(AddAnotherDogForm, {}) })),
    },
    {
        path: 'addons',
        loader: function () { return PROFILE_STEPS.addOnsForm; },
        element: (_jsx(ValidPostPetRoute, { children: _jsx(AddOnsForm, {}) })),
    },
    {
        path: 'address',
        loader: function () { return PROFILE_STEPS.addressForm; },
        element: (_jsx(ValidAddressRoute, { children: _jsx(AddressForm, {}) })),
    },
    {
        path: 'contact',
        loader: function () { return PROFILE_STEPS.contactForm; },
        element: (_jsx(ValidPostPetRoute, { children: _jsx(ContactInfoForm, {}) })),
    }
], petRoutes, true), [
    {
        path: 'summary',
        loader: function () { return PROFILE_STEPS.summaryForm; },
        element: (_jsx(ValidSummaryRoute, { children: _jsx(CheckoutForm, {}) })),
    },
], false);
export default PersonalizedProfileRoutes;
